// extracted by mini-css-extract-plugin
export var dedicatedInfoBlock = "styles-module--dedicated-info-block--c8bf8";